import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';

import { ContactNote, IContactNote } from 'contact/contact-note';
import { extractAcronym } from 'domain/domain.utils';

import {
	ContactModuleColumn,
	IContactModuleColumn,
} from './contact-module-column';

export interface IContact extends IEntity {
	readonly name: string;
	readonly ownerId: string;
	readonly language: string;
	readonly phoneNumber: string;
	readonly companies: string[];
	readonly categories: string[];
	readonly emailAddress: string;
	readonly lastMeetingTimestamp: number;
	readonly notes: readonly IContactNote[];
	readonly moduleColumns: readonly IContactModuleColumn[];
	readonly acronym: string;

	isInColumn(columnId: string): boolean;
}

export class Contact extends Entity implements IContact {
	private _name: string;
	private _ownerId: string;
	private _language: string;
	private _phoneNumber: string;
	private _companies: string[];
	private _categories: string[];
	private _emailAddress: string;
	private _notes: ContactNote[];
	private _lastMeetingTimestamp: number;
	private _moduleColumns: ContactModuleColumn[];
	private _acronym: string;

	constructor(
		id: string,
		name: string,
		ownerId: string,
		language: string,
		phoneNumber: string,
		companies: string[],
		categories: string[],
		emailAddress: string,
		updateTimestamp: number,
		creationTimestamp: number,
		lastMeetingTimestamp: number,
		notes: ContactNote[],
		moduleColumns: ContactModuleColumn[]
	) {
		super(id, creationTimestamp, updateTimestamp);
		this._name = name;
		this._ownerId = ownerId;
		this._language = language;
		this._companies = companies;
		this._categories = categories;
		this._phoneNumber = phoneNumber;
		this._emailAddress = emailAddress;
		this._notes = notes;
		this._moduleColumns = moduleColumns;
		this._lastMeetingTimestamp = lastMeetingTimestamp;

		this._acronym = extractAcronym(this._name);
	}

	public get name(): string {
		return this._name;
	}

	public get ownerId(): string {
		return this._ownerId;
	}

	public get language(): string {
		return this._language;
	}

	public get phoneNumber(): string {
		return this._phoneNumber;
	}

	public get emailAddress(): string {
		return this._emailAddress;
	}

	public get companies(): string[] {
		return this._companies;
	}

	public get categories(): string[] {
		return this._categories;
	}

	public get notes(): ContactNote[] {
		return this._notes;
	}

	public get lastMeetingTimestamp(): number {
		return this._lastMeetingTimestamp;
	}

	public get moduleColumns(): ContactModuleColumn[] {
		return this._moduleColumns;
	}

	public get acronym(): string {
		return this._acronym;
	}

	public isInColumn(columnId: string): boolean {
		return (this.moduleColumns || []).some((c) => c.columnId === columnId);
	}
}
